module.exports = __webpack_public_path__ + "static/media/New Front Door & Posts (3).c226375b.jpg";